var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "block",
    { staticStyle: { "padding-bottom": "60px" } },
    [
      _c("template", { slot: "header" }, [_vm._v("\n    Nueva Atención\n  ")]),
      _vm._v(" "),
      _c(
        "p",
        {
          staticClass:
            "question has-text-weight-semibold is-uppercase is-size-6"
        },
        [
          _vm._v(
            "\n    ¿desea planificar una atención o agregar una atención ya realizada?\n  "
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "actions" }, [
        _c(
          "button",
          {
            staticClass: "button is-primary",
            on: {
              click: function($event) {
                return _vm.navigateTo("app.profile.new_attention")
              }
            }
          },
          [_vm._v("\n      Planificar próxima atención\n    ")]
        ),
        _vm._v("\n     \n    "),
        _c(
          "button",
          {
            staticClass: "button is-primary",
            on: {
              click: function($event) {
                return _vm.navigateTo("app.profile.new_past_attention")
              }
            }
          },
          [_vm._v("\n      Agregar atención realizada\n    ")]
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }